export default __webpack_public_path__ + "static/media/11.4be000de.jpg";